import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../state-management/rootReducer';

const initialState: Invitee[] = [];

export const inviteeSlice = createSlice({
  name: 'invitees',
  initialState: initialState,
  reducers: {
    setInvitees: (
      state: Invitee[] = [],
      action: PayloadAction<Invitee[]>
    ) => {
      return [...action.payload];
    },
    removeInvitee: (
      state: Invitee[] = [],
      action: PayloadAction<string>
    ) => {
      return state.filter((invitee) => invitee.id !== action.payload);
    },
  },
});

export const { setInvitees, removeInvitee } = inviteeSlice.actions;

export const getInvitees = (state: RootState) => state.invitees;

export default inviteeSlice.reducer;
